import { FC, Fragment, useContext } from 'react';
import { ProposalFlight, ProposalHotel } from 'ts/shared/interfaces/ProposalData';
import ProposalHtl from './ProposalHtl';
import ProposalFlt from './ProposalFlt';
import { useTranslation } from 'react-i18next';
import ProposalEditHead from './ProposalEditHead';
import useRemovedItem from './useRemovedItem';
import { checkAHAVI } from 'utils/utils';
import withErrorBoundary from '../../withErrorBoundary';
import { dateFormat } from 'utils/shared/utils';
import { formatFltPersons } from 'utils/shared/proposal';
import { MainContext } from 'contexts/MainContext';

interface ProposalDynProps {
  flights?: ProposalFlight[];
  hotels?: ProposalHotel[];
  ticket: any;
  displayPrice: boolean;
  proposalId: string;
  currency?: string;
}

const ProposalDyn: FC<ProposalDynProps> = ({ flights, hotels, ...props }) => {
  const { t } = useTranslation();
  const removedItem = useRemovedItem(props.proposalId);
  const { cdnUrl } = useContext(MainContext);

  let attraction = {} as any;
  if (props.ticket?.listOfSportActivityOption?.length) {
    attraction.category = props.ticket?.listOfSportActivityOption.find(
      (opt: any) => opt.description === 'Category'
    )?.value;

    attraction.date = props.ticket?.listOfSportActivityOption.find(
      (opt: any) => opt.description === 'Date'
    )?.value;

    attraction.city = props.ticket?.listOfSportActivityOption.find(
      (opt: any) => opt.description === 'City'
    )?.value;

    attraction.country = props.ticket?.listOfSportActivityOption.find(
      (opt: any) => opt.description === 'Country'
    )?.value;

    attraction.team1Logo = props.ticket?.listOfSportActivityOption.find(
      (opt: any) => opt.description === 'Team1logo'
    )?.value;

    attraction.team2Logo = props.ticket?.listOfSportActivityOption.find(
      (opt: any) => opt.description === 'Team2logo'
    )?.value;

    attraction.image = props.ticket?.listOfSportActivityOption.find(
      (opt: any) => opt.description === 'Image'
    )?.value;

    attraction.imageLink = props.ticket?.listOfSportActivityOption.find(
      (opt: any) => opt.description === 'ImageLink'
    )?.value;

    attraction.vanueDesc = props.ticket?.listOfSportActivityOption.find(
      (opt: any) => opt.description === 'VanueDesc'
    )?.value;

    attraction.ticketDesc = props.ticket?.listOfSportActivityOption.find(
      (opt: any) => opt.description === 'TicketDesc'
    )?.value;
  }
  const dynText = [
    flights ? 'flight.flight' : '',
    hotels ? 'hotel.hotel' : '',
    props.ticket ? 'dyn.ticket' : '',
  ]
    .filter(Boolean)
    .map((tr) => t(tr));

  return (
    <div className="pr-hotel-card-wr">
      <div className={'pr-hotel-card' + (removedItem ? ' pr-hotel-removed' : '')}>
        <div className="pr-hotel-card-title pr-flex-between">
          <div>
            {dynText.length > 1 && <span>{t('proposal.dynamic')} - </span>} {dynText.join(' & ')}
          </div>
          <ProposalEditHead proposalId={props.proposalId} displayPrice={props.displayPrice} />
        </div>

        {!!hotels && (
          <ProposalHtl
            hotels={hotels}
            hideWrapper
            displayPrice={false}
            proposalId={props.proposalId}
          />
        )}

        {!!flights && (
          <Fragment>
            <div className="mt-20"></div>
            <div className="pr-hotel-title pr-flex-row">
              {t('flight.flight')}:{' '}
              <div className="pr-flex-row pr-ph-5">
                {flights[0].gdsFlyAirs.map((bound, index) => (
                  <span key={index} className="pr-flex-row">
                    <span className="pr-mr-3">
                      {bound.departureAirport.code} - {bound.arrivalAirport.code},{' '}
                    </span>
                    <span>{dateFormat(bound.departureDateTime, 'dd/MM', 'en')}</span>

                    {index !== flights[0].gdsFlyAirs.length - 1 && (
                      <span className="pr-ph-3">|</span>
                    )}
                  </span>
                ))}
                ,<span className="pr-ph-3">{formatFltPersons(flights[0], t)}</span>
              </div>
            </div>
            <ProposalFlt
              flight={flights[0]}
              hideWrapper
              currency={props.currency}
              proposalId={props.proposalId}
              displayPrice={false}
            />
          </Fragment>
        )}

        {!!props.ticket && (
          <Fragment>
            <div className="mt-20"></div>
            <div className="pr-hotel-title">
              {t('dyn.ticket')}:{' '}
              <span>
                {props.ticket.name}, {dateFormat(attraction.date, 'dd/MM/yyyy - HH:mm')}
              </span>
            </div>
            <div className="pr-ticket">
              <div className="pr-ticket-logo">
                <img src={attraction.image} alt="1" />
              </div>
              <div className="pr-ticket-info">
                <div>
                  <div className="pr-ticket-title">
                    <span className="pr-ticket-title-1">{props.ticket.name.split(' - ')?.[0]}</span>
                    <span> - </span>
                    <span className="pr-ticket-title-2">{props.ticket.name.split(' - ')?.[1]}</span>
                  </div>
                  <div>{attraction.category}</div>
                  <div>
                    {attraction.city}, {attraction.country}
                  </div>
                  <div className="">{attraction.vanueDesc}</div>
                  <div className="text-sm">{attraction.ticketDesc}</div>
                </div>
              </div>
              <div className="ml-a"></div>
              <div className="pr-ticket-total">
                <div className="pr-ticket-total-images">
                  {!!attraction.team1Logo && (
                    <div className="pr-ticket-img">
                      <img src={cdnUrl + attraction.team1Logo} alt="1" className="img-box-shadow" />
                    </div>
                  )}
                  {!!attraction.team2Logo && (
                    <div className="pr-ticket-img">
                      <img src={cdnUrl + attraction.team2Logo} alt="1" className="img-box-shadow" />
                    </div>
                  )}
                  {!!attraction.imageLink && (
                    <div className="pr-ticket-cat">
                      <img src={attraction.imageLink} alt="1" className="img-box-shadow" />
                    </div>
                  )}
                </div>

                <div className="pr-ticket-total-date">
                  {dateFormat(attraction.date, 'dd/MM/yyyy - HH:mm')}
                </div>
              </div>
            </div>
            {props.ticket?.displayNote?.name && (
              <div
                className={
                  'pr-notes' + (checkAHAVI(props.ticket?.displayNote?.name) ? ' pr-rtl' : ' pr-ltr')
                }
              >
                <span className="pr-mr-5">{t('notes')}: </span>
                <div
                  className="pr-bold"
                  dangerouslySetInnerHTML={{
                    __html: props.ticket?.displayNote?.name?.replaceAll(/\n/g, '<br />'),
                  }}
                ></div>
              </div>
            )}
          </Fragment>
        )}
      </div>

      <div className="pr-divider"></div>
    </div>
  );
};

export default withErrorBoundary(ProposalDyn, 'ProposalDyn');
